import type { AxiosResponse } from 'axios';
import { apiClient } from '../../../helpers';
import { handleError, URL_GESTIFY_ANAGRAFICHE } from '../../../utils';
import { AnagraficaFetchParams } from '../../../models';
import { getGestifyTokenCookies } from '../../../helpers/authCookies';

export const gestifyFetchAnagrafica = async ({
  id,
  ...params
}: AnagraficaFetchParams) => {
  try {
    const token = getGestifyTokenCookies().gestifyToken;
    const response = await apiClient.get<AxiosResponse>({
      url: `${URL_GESTIFY_ANAGRAFICHE}/${id}`,
      params: { ...params, token },
    });
    if (response.status === 200) {
      return response.data;
    }
    return handleError(response.status, response.data?.status);
  } catch (error: any) {
    return handleError(
      error?.response?.status ?? error?.message,
      error?.response?.data,
    );
  }
};
